// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JIe8","importantInfo":"styles_importantInfo__2it-N"};